export const SITE_NAME = 'VeilStream'

const DEFAULT_DESCRIPTION =
  'Preview environments, databases, and session recordings on VeilStream.'

function setMetaAttr(attr: 'name' | 'property', key: string, content: string) {
  const selector = `meta[${attr}="${key}"]`
  let el = document.querySelector(selector) as HTMLMetaElement | null
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.content = content
}

/** Update document title and link-preview meta tags (Open Graph / Twitter). */
export function setPageMeta(opts: { title?: string; description?: string; image?: string }) {
  if (opts.title != null) {
    document.title = opts.title
    setMetaAttr('property', 'og:title', opts.title)
    setMetaAttr('name', 'twitter:title', opts.title)
  }
  if (opts.description != null) {
    setMetaAttr('name', 'description', opts.description)
    setMetaAttr('property', 'og:description', opts.description)
    setMetaAttr('name', 'twitter:description', opts.description)
  }
  if (opts.image != null) {
    setMetaAttr('property', 'og:image', opts.image)
    setMetaAttr('name', 'twitter:image', opts.image)
    setMetaAttr('name', 'twitter:card', 'summary_large_image')
  }
}

export function resetPageMeta(isDev: boolean) {
  setPageMeta({
    title: isDev ? `${SITE_NAME} - Dev` : SITE_NAME,
    description: DEFAULT_DESCRIPTION,
  })
}
